import styled from "styled-components";

import CopyText from "components/CopyText";

import { LinkTextMixin, NoBorderButton } from "uikit";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
`;
